import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ProfileService } from 'src/app/modules/profile-module/profile.service';
import { UserService } from '../../pages/auth/UserDetails/user.service';
import { GlobalStorage } from '../../../core/Gloabl/Global';
import { Notification } from '../../../core/Notifications/Notification';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  userdata: any;
  image_Url: string;
  headerMessage: string = 'Welcome to Dashboard';

  constructor(
    private router: Router,
    private user: UserService,
    private store: GlobalStorage,
    private Notifi: Notification,
    private service: ProfileService
  ) {}

  ngOnInit(): void {
    // ✅ Run check immediately on load (fix for reload)
    this.updateHeaderMessage(this.router.url);

    // ✅ Also update dynamically on route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateHeaderMessage(event.urlAfterRedirects);
      });

    // Load user image
    this.service.currentUserImage.subscribe(data => {
      if (data) this.image_Url = data;
    });

    this.get_profile();
  }

  // ✅ Update navbar message
  updateHeaderMessage(url: string) {
   if (url.includes('/base/dashboard/student-details/')) {
    this.headerMessage = 'Student Report';
  } else if (url.includes('/base/dashboard/ranks')) {
    this.headerMessage = '';
  } else {
    this.headerMessage = 'Welcome to Dashboard';
  }
  }

  onUserAction(event: any) {
    const selectedValue = event.target.value;
    if (selectedValue === 'logout') this.onLogout();
  }

  onLogout() {
    this.user.logout();
    this.router.navigate(['/auth/login']);
  }

  get_profile() {
    this.service.Get_Userprofile().subscribe(data => {
      this.userdata = data;
      this.image_Url = this.userdata?.imagename;
    });
  }
}
